import { fetchAemSearchResultsData } from "@/services/aem";
import { AemSearchDropDown, AemSearchResults } from "@/utils/types/aem";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

type SearchResultsState = {
  dropdown: AemSearchDropDown | null;
  resultsPage: AemSearchResults | null;
  loading: boolean;
};

const initialState: SearchResultsState = {
  dropdown: null,
  resultsPage: null,
  loading: false,
};

const dataSlice = createSlice({
  name: "aemStaticSearchData",
  initialState,
  reducers: {
    // Action for setting server-side data
    setServerSideData: (
      state,
      action: PayloadAction<{
        dropdown: AemSearchDropDown;
        resultsPage: AemSearchResults;
      }>
    ) => {
      state.dropdown = action.payload.dropdown;
      state.resultsPage = action.payload.resultsPage;
      state.loading = false;
    },
    // Optionally keep a loading state setter if needed
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAemSearchResults.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAemSearchResults.fulfilled, (state, action) => {
        state.loading = false;
        state.resultsPage = action.payload;
      })
      .addCase(fetchAemSearchResults.rejected, (state) => {
        state.loading = false;
        state.resultsPage = null;
      });
  },
});
export const fetchAemSearchResults = createAsyncThunk(
  "aemStaticSearchData/fetchAemSearchResults",
  async () => {
    const response = await fetchAemSearchResultsData();
    return response;
  }
);

// Export actions
export const { setServerSideData, setLoading } = dataSlice.actions;

export default dataSlice.reducer;
